<template>
    <component
        :is="data.component"
        v-bind="data.props"
        class="promotions__item-button-wrapper"
    >
        <SdsButtonText
            variant="primary"
            size="md"
            hasChevron
            class="btn--promotions-details"
        >
            <slot />
        </SdsButtonText>
    </component>
</template>
<script>
    import { SdsButtonText } from '@superbet-group/web.lib.ui-components';
    export default {
        props: {
            link: {
                type: String,
                required: true,
            },
        },
        computed: {
            data() {
                // Internal link
                if (this.link.startsWith('/')) {
                    return {
                        component: 'router-link',
                        props: {
                            to: this.link,
                        },
                    };
                }

                return {
                    component: 'a',
                    props: {
                        href: this.link,
                        target: '_blank',
                    },
                };
            },
        },
        components: {
            SdsButtonText,
        },
    };
</script>
